import React, { useState } from 'react';

const StarIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      className="ef-star-outline"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
    />
  </svg>
);

const StarRating = ({ value, onChange }) => {
  const [hoverValue, setHoverValue] = useState(0);

  const activeUpTo = hoverValue || value;

  return (
    <div>
      <div className="ef-stars" role="radiogroup" aria-label="Star rating">
        {[1, 2, 3, 4, 5].map((star) => {
          const isActive = star <= activeUpTo;
          return (
            <button
              key={star}
              type="button"
              className={[
                'ef-star-btn',
                value >= star ? 'ef-star-btn--active' : '',
                hoverValue >= star && !value ? 'ef-star-btn--hover-preview' : '',
                isActive && hoverValue ? 'ef-star-btn--hover-preview' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => onChange(star)}
              onMouseEnter={() => setHoverValue(star)}
              onMouseLeave={() => setHoverValue(0)}
              aria-label={`${star} star${star > 1 ? 's' : ''}`}
              aria-checked={value === star}
              role="radio"
            >
              <StarIcon />
            </button>
          );
        })}
      </div>
      <div className="ef-scale-labels">
        <span>1</span>
        <span>5</span>
      </div>
    </div>
  );
};

export default StarRating;
